const sessionStorageKeyConnect = 'merchant-connect-oauth-connect';
const sessionStorageKeySignup = 'merchant-connect-oauth-signup';

export const merchantoauthSessionKeys = {
  connect: {
    error: `${sessionStorageKeyConnect}-error`,
    success: `${sessionStorageKeyConnect}-success`,
    providers: {
      bigcommerce: {
        domain: '.mybigcommerce.com'
      },
      wix: {
        domain: '.wix.com'
      },
      shopify: {
        domain: '.myshopify.com'
      }
    }
  },
  signup: {
    error: `${sessionStorageKeySignup}-error`,
    success: `${sessionStorageKeySignup}-success`,
    conflict: `${sessionStorageKeySignup}-conflict`
  }
};
